<template>
  <div>
    <ContentDeclared ref="dc" v-on:saved="saveDc" />
    <el-dialog top="2vh" title="Colunas" :visible.sync="dialog" v-loading="loading" width="50%">
      <el-form ref="form" label-width="160px">
        <table class="table">
          <thead>
            <th class="w-33">Colunas</th>
            <th class="w-33">Campo</th>
            <th class="w-33">Valor Planilha</th>
          </thead>
          <tbody>
            <tr v-for="record of data" :key="record.index">
              <td>
                <el-tag type="primary">{{ record.column }}</el-tag>
              </td>
              <td>
                <el-tag type="info">{{ record.field }}</el-tag>
              </td>
              <td>
                <el-input v-model="record.value"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="save">Salvar</el-button>
        <el-button @click="dialog = false">Cancelar</el-button>
      </span>
    </el-dialog>
    <el-row :gutter="5">
      <el-table v-if="xml && xml.tag" :data="xml.tag" style="width: 100%" v-loading="loading" :row-class-name="tableRowClassName">
        <el-table-column label="Etiqueta" property="tag" />
        <el-table-column label="Peso" property="weight" />
        <el-table-column label="Valor" property="value" />
        <el-table-column label="Resultado" property="result">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 'Erro' ? 'danger' : scope.row.status === 'Sucesso' ? 'success' : 'info'"
              >{{ scope.row.result }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>

      <el-table v-else-if="isCsvFileValidation" :data="tableData" style="width: 100%" v-loading="loading" :row-class-name="tableRowClassName">
        <el-table-column type="index" label="Linha" width="100" />
        <el-table-column label="Status" property="status" width="150">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 'Erro' ? 'danger' : scope.row.status === 'Sucesso' ? 'success' : 'info'"
              >{{ scope.row.status }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="Resultado" property="result" />
        <el-table-column label="#" width="140">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 'Erro'" type="info" icon="el-icon-edit" @click="correct(scope.row)"
              >Corrigir</el-button
            >
            <el-button v-if="scope.row.status === 'Sucesso'" type="primary" @click="dc(scope.row)"
              >Declaração</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- DADOS DE NOTA FISCAL -->
    <el-row v-if="hasInvoices">
      <div class="validate-title">
        <span>Notas fiscais ({{ tableData.length }})</span>
        <el-tag v-if="invoiceErrorCount" type="danger" size="small">{{ invoiceErrorCount }} com erro</el-tag>
        <el-tag v-else type="success" size="small">Todas válidas</el-tag>
      </div>
        <el-table
          :data="tableData.map(r => r.data)"
          border
          stripe
          style="width: 100%"
          height="65vh"
          v-loading="loading"
        >
          <!-- Campos fixos da nota -->
          <el-table-column label="Status" width="320" fixed>
            <template slot-scope="{ row, $index }">
              <div v-if="hasAnyFieldError(row)" class="status-errors">
                <el-tag
                  v-for="(msg, key) in row._fieldErrors"
                  :key="key"
                  type="danger"
                  size="small"
                  class="status-tag status-error-link"
                  title="Clique para ir até o campo"
                  @click.native="goToField($index, key)"
                >
                <span class="status-error-text">
                  {{ msg }}
                </span>
                <i class="el-icon-arrow-right"></i>
                </el-tag>
              </div>
              <el-tag v-else class="status-tag" :type="row._statusColor">{{ row._statusMessage }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="NUMERO" label="N° da nota" min-width="110" />
          <el-table-column prop="SERIE" label="N° de série" min-width="100" />
          <el-table-column prop="ROW_RAW.key" label="Chave" min-width="340" />
          <el-table-column prop="VALOR_TOTAL" label="Valor Total Nota" min-width="130" />

          <!-- Campos do remetente -->
          <el-table-column label="Nome Remetente" min-width="220" class-name="col-emitter-name">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.name" :maxlength="senderNameMaxLength" :title="fieldError(row, 'emitter.name')" :class="{ 'input-error': hasFieldError(row, 'emitter.name') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Endereço Remetente" min-width="220" class-name="col-emitter-address">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.address" :title="fieldError(row, 'emitter.address')" :class="{ 'input-error': hasFieldError(row, 'emitter.address') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Complemento Remetente" min-width="170" class-name="col-emitter-complement">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.complement" :title="fieldError(row, 'emitter.complement')" :class="{ 'input-error': hasFieldError(row, 'emitter.complement') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Número Remetente" min-width="120" class-name="col-emitter-number">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.number" :title="fieldError(row, 'emitter.number')" :class="{ 'input-error': hasFieldError(row, 'emitter.number') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Estado Remetente" min-width="110" class-name="col-emitter-uf">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.uf" :title="fieldError(row, 'emitter.uf')" :class="{ 'input-error': hasFieldError(row, 'emitter.uf') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Cidade Remetente" min-width="170" class-name="col-emitter-city">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.city" size="mini" :title="fieldError(row, 'emitter.city')" :class="{ 'input-error': hasFieldError(row, 'emitter.city') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="CEP Remetente" min-width="120" class-name="col-emitter-cep">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.emitter.cep" :title="fieldError(row, 'emitter.cep')" :class="{ 'input-error': hasFieldError(row, 'emitter.cep') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <!-- Campos do destinatário -->
          <el-table-column label="Nome Destinatário" min-width="220" class-name="col-recipient-name">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.name" size="mini" :title="fieldError(row, 'recipient.name')" :class="{ 'input-error': hasFieldError(row, 'recipient.name') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Endereço Destinatário" min-width="220" class-name="col-recipient-address">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.address" size="mini" :title="fieldError(row, 'recipient.address')" :class="{ 'input-error': hasFieldError(row, 'recipient.address') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Complemento Destinatário" min-width="170" class-name="col-recipient-complement">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.complement" size="mini" :title="fieldError(row, 'recipient.complement')" :class="{ 'input-error': hasFieldError(row, 'recipient.complement') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Número Destinatário" min-width="130" class-name="col-recipient-number">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.number" size="mini" :title="fieldError(row, 'recipient.number')" :class="{ 'input-error': hasFieldError(row, 'recipient.number') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Estado Destinatário" min-width="110" class-name="col-recipient-uf">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.uf" size="mini" :title="fieldError(row, 'recipient.uf')" :class="{ 'input-error': hasFieldError(row, 'recipient.uf') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="CEP Destinatário" min-width="120" class-name="col-recipient-cep">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.cep" size="mini" :title="fieldError(row, 'recipient.cep')" :class="{ 'input-error': hasFieldError(row, 'recipient.cep') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Bairro Destinatário" min-width="170" class-name="col-recipient-neighborhood">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.neighborhood" size="mini" :title="fieldError(row, 'recipient.neighborhood')" :class="{ 'input-error': hasFieldError(row, 'recipient.neighborhood') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <el-table-column label="Cidade Destinatário" min-width="170" class-name="col-recipient-city">
            <template slot-scope="{ row }">
              <el-input v-model="row.ROW_RAW.recipient.city" size="mini" :title="fieldError(row, 'recipient.city')" :class="{ 'input-error': hasFieldError(row, 'recipient.city') }" @change="revalidateRow(row)" />
            </template>
          </el-table-column>
          <!-- Serviço -->
          <el-table-column label="Serviço" min-width="200" class-name="col-servico">
            <template slot-scope="{ row }">
              <el-select v-model="row.servico" placeholder="Selecione" size="mini" :title="fieldError(row, 'servico')" :class="{ 'input-error': hasFieldError(row, 'servico') }" @change="revalidateRow(row)">
                <el-option
                  v-for="opt in serviceOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </template>
          </el-table-column>

          <!-- Seleções de SIM/NÃO -->
          <el-table-column label="Valor Declarado" min-width="140" class-name="col-vd">
            <template slot-scope="{ row }">
              <el-select v-model="row.vd" placeholder="Selecione" size="mini" :title="fieldError(row, 'vd')" :class="{ 'input-error': hasFieldError(row, 'vd') }" @change="revalidateRow(row)">
                <el-option label="SIM" value="SIM" />
                <el-option label="NÃO" value="NÃO" />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="A.R." min-width="120" class-name="col-ar">
            <template slot-scope="{ row }">
              <el-select v-model="row.ar" placeholder="Selecione" size="mini" :title="fieldError(row, 'ar')" :class="{ 'input-error': hasFieldError(row, 'ar') }" @change="revalidateRow(row)">
                <el-option label="SIM" value="SIM" />
                <el-option label="NÃO" value="NÃO" />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="A.R. Digital" min-width="130" class-name="col-arDigital">
            <template slot-scope="{ row }">
              <el-select v-model="row.arDigital" placeholder="Selecione" size="mini" :title="fieldError(row, 'arDigital')" :class="{ 'input-error': hasFieldError(row, 'arDigital') }" @change="revalidateRow(row)">
                <el-option label="SIM" value="SIM" />
                <el-option label="NÃO" value="NÃO" />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="Mão Própria" min-width="130" class-name="col-maoPropria">
            <template slot-scope="{ row }">
              <el-select v-model="row.maoPropria" placeholder="Selecione" size="mini" :title="fieldError(row, 'maoPropria')" :class="{ 'input-error': hasFieldError(row, 'maoPropria') }" @change="revalidateRow(row)">
                <el-option label="SIM" value="SIM" />
                <el-option label="NÃO" value="NÃO" />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="Artigos Perigosos" min-width="150" class-name="col-artigosPerigosos">
            <template slot-scope="{ row }">
              <el-select v-model="row.artigosPerigosos" placeholder="Selecione" size="mini" :title="fieldError(row, 'artigosPerigosos')" :class="{ 'input-error': hasFieldError(row, 'artigosPerigosos') }" @change="revalidateRow(row)">
                <el-option label="SIM" value="SIM" />
                <el-option label="NÃO" value="NÃO" />
              </el-select>
            </template>
          </el-table-column>

          <!-- Produtos -->
          <el-table-column label="Produtos" min-width="130">
            <template slot-scope="{ row }">
              <el-button
                type="info"
                icon="el-icon-search"
                size="mini"
                @click="openProducts(row)"
              >
                Ver Detalhes
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="Celular" min-width="160" class-name="col-recipient-phone">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.ROW_RAW.recipient.phone"
                size="mini"
                :title="fieldError(row, 'recipient.phone')"
                :class="{ 'input-error': hasFieldError(row, 'recipient.phone') }"
                @change="revalidateRow(row)"
                placeholder="11987654321"
              />
            </template>
          </el-table-column>

          <el-table-column prop="pesoTotal" label="Peso Total (g)" min-width="130" />
          <el-table-column prop="altura" label="Altura (cm)" min-width="110" />
          <el-table-column prop="largura" label="Largura (cm)" min-width="110" />
          <el-table-column prop="comprimento" label="Comprimento (cm)" min-width="150" />
        </el-table>
      <!-- TELA DE PRODUTOS CATALOGADOS -->
      <el-dialog
        title="Produtos da Nota"
        :visible.sync="dialogProducts"
        width="60%"
      >
        <el-table
          v-if="selectedProducts.length"
          :data="selectedProducts"
          border
          stripe
        >
          <el-table-column prop="description" label="Descrição" />
          <el-table-column prop="quantity" label="Qtd" width="100" />
          <el-table-column prop="unitValue" label="V. Unitário" width="120" />
          <el-table-column prop="totalValue" label="V. Total" width="120" />
        </el-table>

        <div v-else style="text-align: center; padding: 20px;">
          <el-empty description="Nenhum produto encontrado" />
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogProducts = false">Fechar</el-button>
        </span>
      </el-dialog>
    </el-row> 
    <div class="validate-footer">
      <el-button @click="back()">Voltar</el-button>
      <el-button type="primary" v-if="xml && xml.tag" @click="prepost()">Importar postagens</el-button>
      <el-button type="primary" v-else-if="isCsvFileValidation" @click="create()">Verifica cotações</el-button>
      <template v-if="hasInvoices">
        <el-button icon="el-icon-refresh" :loading="loading" @click="revalidateAll()">Revalidar notas</el-button>
        <el-tooltip
          :disabled="invoiceErrorCount === 0"
          content="Corrija os erros destacados na tabela para liberar a cotação"
          placement="top"
        >
          <span class="validate-cotar-wrap">
            <el-button type="primary" :disabled="invoiceErrorCount > 0" @click="quoteInvoices()">
              Cotar NFEs<template v-if="invoiceErrorCount"> ({{ invoiceErrorCount }} com erro)</template>
            </el-button>
          </span>
        </el-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { CustomerService } from "@/services/customers/customers.services";
import { PrepostService } from "@/services/customers/prepost.services";
import { UploadService } from "@/services/customers/upload.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import PrePostDC from "@/xpost/views/services/pre.post/components/PrePostDC";
import ContentDeclared from "./ContentDeclared.vue";

// Limite do nome do remetente: mesmo valor do backend (MaxLength(50) no DTO de pré-postagem) e do prepost
const SENDER_NAME_MAX_LENGTH = 50;

// O nome do remetente é dado da própria empresa, então pode ser cortado em vez de barrar a importação
function truncateSenderName(value) {
  return String(value == null ? "" : value).trim().substring(0, SENDER_NAME_MAX_LENGTH).trim();
}

export default {
  name: "ImportPrepost",
  props: ["fileData", "columnData", "customer", "xml", "detectNFe"],
  components: {
    PrePostDC,
    ContentDeclared,
  },
  data() {
    return {
      tableData: [],
      prepostList: [],
      data: [],
      cardpost: "",
      current: null,
      loading: false,
      dialog: false,

      tableColumns: [],
      localOptions: { ...this.options },
      serviceOptions: [],
      dialogProducts: false,
      selectedProducts: [],
      selectedRowKey: null,
      prepostagens: [],
      senderNameMaxLength: SENDER_NAME_MAX_LENGTH,
    };
  },
  async mounted() {
    const vm = this;
    console.log("DETECTOU NFE? ", vm.detectNFe)
    if (vm.detectNFe) {
      if (!vm.fileData || vm.fileData.length === 0) {
        console.warn("Nenhum dado encontrado em fileData.");
        return;
      }

      if (vm.fileData && vm.fileData.length > 0) {
        vm.tableColumns = Object.keys(vm.fileData[0]);
      }

      let truncatedSenderNames = 0;
      vm.fileData = vm.fileData.map(row => {
        const saved = (row.ROW_RAW && row.ROW_RAW._rowOptions) || {};
        // Nome do remetente acima do limite: corta em vez de marcar a nota com erro
        const emitter = row.ROW_RAW && row.ROW_RAW.emitter;
        if (emitter && emitter.name && String(emitter.name).trim().length > SENDER_NAME_MAX_LENGTH) {
          emitter.name = truncateSenderName(emitter.name);
          truncatedSenderNames++;
        }
        return {
          ...row,
          numeroNota: row.numeroNota || '',
          numeroSerie: row.numeroSerie || '',
          chave: row.key || '',
          valor: row.valor || '',
          nomeRemetente: row.nomeRemetente || '',
          enderecoRemetente: row.enderecoRemetente || '',
          complementoRemetente: row.complementoRemetente || '',
          cepRemetente: row.cepRemetente || '',
          bairroDestinatario: row.bairroDestinatario || '',
          nomeDestinatario: row.nomeDestinatario || '',
          enderecoDestinatario: row.enderecoDestinatario || '',
          complementoDestinatario: row.complementoDestinatario || '',
          cepDestinatario: row.cepDestinatario || '',
          servico: saved.servico || row.servico || (row.options && row.options.servico) || '',
          vd: saved.vd || row.vd || '',
          ar: saved.ar || row.ar || '',
          arDigital: saved.arDigital || row.arDigital || '',
          maoPropria: saved.maoPropria || row.maoPropria || '',
          artigosPerigosos: saved.artigosPerigosos || row.artigosPerigosos || '',
          produtos: row.produtos || [],
          pesoTotal: row.pesoTotal || 300,
          altura: row.altura || 6,
          largura: row.largura || 11,
          comprimento: row.comprimento || 21,
        };
      });

      if (truncatedSenderNames > 0) {
        vm.$message({
          type: "info",
          duration: 6000,
          message: `Nome do remetente cortado para ${SENDER_NAME_MAX_LENGTH} caracteres em ${truncatedSenderNames} nota(s)`,
        });
      }

      await this.loadCustomerServices();

      // Cria tableData com base no fileData enriquecido
      vm.tableData = await Promise.all(vm.fileData.map(async (record, i) => {

        const validation = await vm.validateInvoice(record);

        return {
          index: i,
          status: "Aguardando",
          result: "",
          data: {
            ...record,
            _statusColor: validation.status,
            _statusMessage: validation.message,
            _fieldErrors: validation.fieldErrors || {}
          },
          prepost: null
        }
      }));
      return true;
    }

    // Inicialização de CSV ou XML PLP
      if (vm.fileData.length === 0 || vm.columnData.length === 0) return false;

      for (let i = 0; i < vm.fileData.length; i++) {
        const record = vm.fileData[i];
        vm.tableData.push({ index: i, status: "Aguardando", result: "", data: record, prepost: null });
      }
      vm.loading = true;
      vm.fileData.map(async (data, index) => {
        await vm.setPrepostData(data, index);
        return true;
      });
  },
  computed: {
    isCsvFileValidation() { 
      const vm = this;
      const condition = (vm.fileData.length > 0) && (vm.columnData.length > 0) && (vm.tableData.length > 0);
      return condition;
    },
    formattedTableData() {
      return this.tableData.map(item => ({
        ...item.data,
        status: item.status,
        result: item.result
      }));
    },
    invoiceErrorCount() {
      if (!this.hasInvoices) return 0;
      return this.tableData.filter(function (r) {
        return r.data && r.data._statusColor === "danger";
      }).length;
    },
    hasInvoices() {
      if (!Array.isArray(this.fileData) || this.fileData.length === 0) return false;
      // Detecta se o primeiro item contém campos típicos de uma NF
      const sample = this.fileData[0];
      return (
        sample.NUMERO !== undefined &&
        sample.SERIE !== undefined &&
        sample.ROW_RAW !== undefined &&
        sample.ROW_RAW.emitter !== undefined &&
        sample.ROW_RAW.recipient !== undefined
      );
    },
  },
  methods: {
    normalizeCnpj(cnpj) {
      if (!cnpj) return "";

      const onlyAlphanumeric = String(cnpj).replace(/[^0-9A-Za-z]/g, "").toUpperCase();

      return onlyAlphanumeric.padStart(14, '0');
    },
    async loadCustomerServices() {
      try {
        const response = await CustomerService.get(this.customer);
        this.serviceOptions = response.service.map(s => ({
          label: s.name,
          value: s.code,
          modalityCode: s.modalityCode
        }));
      } catch (error) {
        console.error(error);
      }
    },
    errorMessage(e) {
      return (
        (e && e.response && e.response.data && e.response.data.message) ||
        (e && e.message) ||
        String(e)
      );
    },
    backendErrorField(message) {
      const msg = String(message || "").toLowerCase();
      if (msg.indexOf("valor declarado") !== -1) return "vd";
      if (msg.indexOf("mão própria") !== -1 || msg.indexOf("mao propria") !== -1) return "maoPropria";
      if (msg.indexOf("artigos perigosos") !== -1) return "artigosPerigosos";
      if (msg.indexOf("cep") !== -1 && msg.indexOf("remet") !== -1) return "emitter.cep";
      if (msg.indexOf("cep") !== -1) return "recipient.cep";
      if (msg.indexOf("celular") !== -1 || msg.indexOf("telefone") !== -1) return "recipient.phone";
      if (msg.indexOf("servi") !== -1) return "servico";
      return null;
    },
    fieldError(row, key) {
      return (row._fieldErrors && row._fieldErrors[key]) || null;
    },
    hasFieldError(row, key) {
      return !!this.fieldError(row, key);
    },
    hasAnyFieldError(row) {
      return !!(row._fieldErrors && Object.keys(row._fieldErrors).length);
    },
    goToField(rowIndex, key) {
      const cls = "col-" + key.replace(/\./g, "-");
      const body = this.$el.querySelector(".el-table__body-wrapper");
      if (!body) return;
      const rows = body.querySelectorAll("tr.el-table__row");
      const rowEl = rows[rowIndex];
      if (!rowEl) return;
      const cell = rowEl.querySelector("." + cls);
      if (!cell) return;
      cell.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      const input = cell.querySelector("input");
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 350);
      }
    },
    persistRowOptions(row) {
      if (!row.ROW_RAW) return;
      row.ROW_RAW._rowOptions = {
        servico: row.servico,
        vd: row.vd,
        ar: row.ar,
        arDigital: row.arDigital,
        maoPropria: row.maoPropria,
        artigosPerigosos: row.artigosPerigosos,
      };
    },
    async revalidateRow(row) {
      this.persistRowOptions(row);
      const validation = await this.validateInvoice(row);
      row._statusColor = validation.status;
      row._statusMessage = validation.message;
      row._fieldErrors = validation.fieldErrors;
    },
    async revalidateAll() {
      const vm = this;
      vm.loading = true;
      try {
        for (const record of vm.tableData) {
          await vm.revalidateRow(record.data);
        }
      } finally {
        vm.loading = false;
      }
    },
    async validateInvoice(row) {
      var errors = [];
      var fieldErrors = {};
      const addError = function (key, msg) {
        errors.push(msg);
        if (key && !fieldErrors[key]) fieldErrors[key] = msg;
      };

      var emitter = (row.ROW_RAW && row.ROW_RAW.emitter) ? row.ROW_RAW.emitter : {};
      var recipient = (row.ROW_RAW && row.ROW_RAW.recipient) ? row.ROW_RAW.recipient : {};

      // ---- SERVIÇO ----
      if (!row.servico) {
        addError("servico", "Serviço não selecionado");
      } else {
        // Serviços com modalidade (ex.: Expresso 1 / Econômico 1) exigem valor declarado
        var selectedService = this.serviceOptions.find(function (s) {
          return s.value === row.servico;
        });
        if (selectedService && selectedService.modalityCode && row.vd !== "SIM") {
          addError("vd", "Para o serviço " + selectedService.label + ", o Valor Declarado é obrigatório (marque SIM)");
        }
      }

      // ---- OBRIGATÓRIOS ----
      var requiredFields = [
        { key: "emitter.name", label: "Nome do Remetente", value: emitter.name },
        { key: "emitter.address", label: "Endereço do Remetente", value: emitter.address },
        { key: "emitter.number", label: "Número do Remetente", value: emitter.number },
        { key: "emitter.city", label: "Cidade do Remetente", value: emitter.city },
        { key: "recipient.name", label: "Nome do Destinatário", value: recipient.name },
        { key: "recipient.address", label: "Endereço do Destinatário", value: recipient.address },
        { key: "recipient.number", label: "Número do Destinatário", value: recipient.number },
        { key: "recipient.neighborhood", label: "Bairro do Destinatário", value: recipient.neighborhood },
        { key: "recipient.city", label: "Cidade do Destinatário", value: recipient.city },
      ];

      requiredFields.forEach(function (f) {
        if (!String(f.value == null ? "" : f.value).trim()) {
          addError(f.key, f.label + " é obrigatório");
        }
      });

      // ---- UF ----
      var ufs = [
        { key: "emitter.uf", label: "Estado do Remetente", value: emitter.uf },
        { key: "recipient.uf", label: "Estado do Destinatário", value: recipient.uf },
      ];

      ufs.forEach(function (f) {
        if (!/^[A-Za-z]{2}$/.test(String(f.value || "").trim())) {
          addError(f.key, f.label + " deve ser a UF com 2 letras");
        }
      });

      var fieldsToCheck = [
        { key: "emitter.name", label: "Nome do Remetente", value: emitter.name, max: 50 },
        { key: "recipient.name", label: "Nome do Destinatário", value: recipient.name, max: 50 },
        { key: "emitter.address", label: "Endereço Remetente", value: emitter.address, max: 50 },
        { key: "recipient.address", label: "Endereço Destinatário", value: recipient.address, max: 50 },
        { key: "emitter.complement", label: "Complemento Remetente", value: emitter.complement, max: 40 },
        { key: "recipient.complement", label: "Complemento Destinatário", value: recipient.complement, max: 40 },
        { key: "emitter.number", label: "Número Remetente", value: emitter.number, max: 6 },
        { key: "recipient.number", label: "Número Destinatário", value: recipient.number, max: 6 },
        { key: "emitter.city", label: "Cidade Remetente", value: emitter.city, max: 40 },
        { key: "recipient.city", label: "Cidade Destinatário", value: recipient.city, max: 40 },
        { key: "recipient.neighborhood", label: "Bairro Destinatário", value: recipient.neighborhood, max: 40 },
      ];

      fieldsToCheck.forEach(function (f) {
        if (f.value && String(f.value).length > f.max) {
          addError(f.key, f.label + " possui mais de " + f.max + " caracteres");
        }
      });

      // ---- TELEFONE (mesma regra do backend: DDD + número com 10 ou 11 dígitos) ----
      var phone = recipient.phone ? String(recipient.phone).replace(/\D/g, "") : "";
      if (phone.indexOf("55") === 0 && (phone.length === 12 || phone.length === 13)) {
        phone = phone.substring(2);
      }
      if (phone.length === 0) {
        addError("recipient.phone", "Telefone do destinatário não informado — DDD + número com 10 ou 11 dígitos");
      } else if (phone.length !== 10 && phone.length !== 11) {
        addError(
          "recipient.phone",
          "Telefone do destinatário com " + phone.length + " dígitos — informe DDD + número com 10 ou 11 dígitos"
        );
      } else if (phone.length === 11 && phone.charAt(2) !== "9") {
        addError(
          "recipient.phone",
          "Telefone do destinatário inválido — com 11 dígitos, o número após o DDD deve começar com 9 (ex.: " + phone.substring(0, 2) + "9********)"
        );
      }

      // ---- CEPs ----//
      var ceps = [
        { key: "emitter.cep", label: "CEP do Remetente", value: emitter.cep },
        { key: "recipient.cep", label: "CEP do Destinatário", value: recipient.cep },
      ];

      for (var i = 0; i < ceps.length; i++) {
        var cep = ceps[i];
        var onlyNumbers = String(cep.value || "").replace(/\D/g, "");

        if (onlyNumbers.length !== 8) {
          addError(cep.key, cep.label + " inválido");
          continue;
        }

        try {
          await PostOfficeService.zipcode(onlyNumbers);
        } catch (e) {
          addError(cep.key, cep.label + " não encontrado nos Correios");
        }
      }

      // ---- RETORNO ----
      if (errors.length === 0) {
        return {
          status: "success",
          message: "Pré-postagem aprovada!",
          fieldErrors: {},
        };
      }

      return {
        status: "danger",
        message: errors.join(" | "),
        fieldErrors: fieldErrors,
      };
    },
    async mapToPrepost(invoice) {
      const valueDce = invoice.DCE_EMITE ? invoice.DCE_EMITE.toLowerCase() : 'nao'
      const emitDce = valueDce === 'sim' || valueDce === 's' || valueDce === 'true' || valueDce === '1' ? true : false

      var emitter = (invoice.ROW_RAW && invoice.ROW_RAW.emitter) ? invoice.ROW_RAW.emitter : {};
      var recipient = (invoice.ROW_RAW && invoice.ROW_RAW.recipient) ? invoice.ROW_RAW.recipient : {};
      var products = (invoice.ROW_RAW && invoice.ROW_RAW.products) ? invoice.ROW_RAW.products : [];
      var prepostFromSet =
        invoice.prepost && typeof invoice.prepost === "object"
          ? invoice.prepost
          : null;

      /** --- PREPOST BASE (para QuotationObject) --- */
      var prepostBase = {
        type: invoice.type || "POSTAGEM",

        service:
          (prepostFromSet && prepostFromSet.service) ||
          invoice.servico ||
          "",

        value:
          (prepostFromSet && (prepostFromSet.value || 0)) ||
          invoice.VALOR_TOTAL ||
          0,

        sender: {
          cep: String(emitter.cep) || String(invoice.CEP_REM || ""),
          federalId: this.normalizeCnpj(emitter.cnpj || invoice.CNPJ_EMITENTE || ""),
          contact: emitter.name || invoice.NOME_EMITENTE || "",
          address: emitter.address || invoice.ENDERECO_REM || "",
          number: emitter.number || invoice.NUMERO_REM || "",
          extent: String(emitter.complement || invoice.COMPLEMENTO_REM || ""),
          neighborhood: emitter.neighborhood || invoice.BAIRRO_REM || "",
          city: emitter.city || invoice.CIDADE_REM || "",
          state: emitter.uf || invoice.UF_REM || "",
          phone: emitter.phone || invoice.TELEFONE_REM || ""
        },

        delivery: {
          cep: String(recipient.cep) || String(invoice.CEP || ""),
          address: recipient.address || invoice.ENDERECO || "",
          number: recipient.number || invoice.NUMERO || "",
          extent: String(recipient.complement || invoice.COMPLEMENTO || ""),
          neighborhood: recipient.neighborhood || invoice.BAIRRO || "",
          city: recipient.city || invoice.CIDADE || "",
          state: recipient.uf || invoice.UF || "",
          phone: recipient.phone || invoice.TELEFONE_DESTINO || "",
          email: recipient.email || invoice.EMAIL_DESTINO || "",
          contact: recipient.name || invoice.NOME_DESTINATARIO || "",
          federalId: recipient.cnpj || invoice.CNPJ_DESTINATARIO || "",
          department: invoice.DEPARTAMENTO || ""
        },

        object: {
          ownhand: (invoice.maoPropria === 'SIM') ? true : false,
          ar: (invoice.ar  === 'SIM') ? true : false,
          weight:
            invoice.pesoTotal ||
            (prepostFromSet && prepostFromSet.object && prepostFromSet.object.weight) ||
            (invoice.ROW_RAW && invoice.ROW_RAW.transport && invoice.ROW_RAW.transport.grossWeight) ||
            0,
          ardigital: (invoice.arDigital  === 'SIM') ? true : false,
          ap: (invoice.artigosPerigosos  === 'SIM') ? true : false
        }
      };

      var prepostExtra = {
        customer: this.customer,
        cardpost: "",
        primary: "",
        pricetable: 0,

        contact: {
          save: false,

          invoice: String(invoice.NUMERO || ""),  // número da NF

          request:
            (products[0] && products[0].orderNumber)
              ? String(products[0].orderNumber)
              : (invoice.orderNumber || ""),

          care:
            recipient.name ||
            invoice.NOME_DESTINATARIO ||
            "",

          mail:
            recipient.email ||
            invoice.EMAIL_DESTINO ||
            "",

          phone:
            recipient.phone ||
            invoice.TELEFONE_DESTINO ||
            "",

          federalid:
            recipient.cnpj ||
            invoice.CNPJ_DESTINATARIO ||
            "",

          observation:
            invoice.observation || "",

          whatsapp: false
        },

        complement: {
          value: (invoice.vd === 'SIM') ? prepostBase.value : 0,
          height: 6,
          length: 11,
          width: 21,
          diameter: 0,
          type: "001",
          typeContent: invoice.ROW_RAW.key ? '1' : emitDce ? '3' : '4',
          nfeKey: invoice.ROW_RAW.key || "",
          nfeValue: String(invoice.VALOR_TOTAL || ""),
          nfeNumber: Number(invoice.ROW_RAW.number || ""),
          nfeSerie: Number(invoice.ROW_RAW.series || ""),
        },

        dc: [],

        nf: {
          nfeValue: String(invoice.VALOR_TOTAL || ""),
          nfeNumber: Number(invoice.ROW_RAW.number || ""),
          nfeSerie: Number(invoice.ROW_RAW.series || ""),
          nfeKey: invoice.ROW_RAW.key || ""
        }
      };

      /** --- JUNÇÃO FINAL --- */
      var prepostFinal = Object.assign({}, prepostBase, prepostExtra);

      var validationError = null;
      try {

        prepostFinal.sender.cep = String(prepostFinal.sender.cep);
        // Aqui ocorre a validação no backend (valor, regras, etc.)
        const validateValue = await PrepostService.validate(prepostFinal);

        // Armazena o valor calculado
        prepostFinal.value = validateValue;
      } catch (e) {
        validationError = this.errorMessage(e);
        prepostFinal.value = 0;
      }

      return {
        error: validationError,
        prepost: prepostFinal,

        products: products.map(function (p) {
          return {
            code: p.code || p.codigo || "",
            description: p.description || p.descricao || "",
            quantity: p.quantity || p.quantidade || 1,
            unitValue: p.unitValue || p.valorUnitario || 0,
            totalValue: p.totalValue || p.valorTotal || 0
          };
        }),

        invoiceNumber: invoice.NUMERO,
        invoiceSeries: invoice.SERIE,
        invoiceKey: invoice.chave || ((invoice.ROW_RAW && invoice.ROW_RAW.key) || ""),
        invoiceTotal: invoice.VALOR_TOTAL,
      };
    },
    async quoteInvoices() {
      const vm = this;

      // Usa tableData pois contém as edições do usuário
      const rows = vm.tableData.map(r => r.data);

      if (!rows.length) {
        return this.$message({
          type: "error",
          message: "Nenhuma NFe encontrada para cotação!"
        });
      }

      vm.loading = true;
      try {
        // Revalida as regras locais (linhas editadas ficam com status atualizado)
        for (const row of rows) {
          await vm.revalidateRow(row);
        }

        const localErrors = rows.filter(r => r._statusColor === "danger");
        if (localErrors.length === rows.length) {
          return this.$message({
            type: "error",
            message: "Todas as notas possuem erros. Corrija os campos destacados em vermelho.",
            duration: 6000,
          });
        }

        // Valida no backend somente as linhas sem erro local
        const validRows = rows.filter(r => r._statusColor !== "danger");
        const records = await Promise.all(
          validRows.map(invoice => vm.mapToPrepost(invoice))
        );

        // Marca na própria linha os erros retornados pelo servidor,
        // apontando o campo quando a mensagem permite identificar
        records.forEach((record, i) => {
          if (record.error) {
            const row = validRows[i];
            row._statusColor = "danger";
            row._statusMessage = "Erro na validação: " + record.error;
            const fieldKey = vm.backendErrorField(record.error);
            if (fieldKey) {
              row._fieldErrors = Object.assign({}, row._fieldErrors, { [fieldKey]: record.error });
            }
          }
        });

        const valid = records.filter(r => !r.error);
        const failed = rows.length - valid.length;

        if (valid.length === 0) {
          return this.$message({
            type: "error",
            message: "Nenhuma nota passou na validação. Verifique os erros na tabela.",
            duration: 6000,
          });
        }

        if (failed > 0) {
          await this.$confirm(
            `${failed} nota(s) estão com erro (veja o status e os campos destacados) e não serão cotadas. Deseja continuar com as ${valid.length} válidas?`,
            i18n.tc("aviso"),
            {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning",
              center: true,
            }
          );
        }

        vm.prepostagens = valid;

        // Emite para o próximo componente (QuotationObject)
        vm.$emit("create", valid);
        vm.$emit("next");
      } catch (e) {
        // $confirm rejeita ao cancelar; qualquer outro erro é exibido
        if (e !== "cancel" && e !== "close") {
          this.$message({ type: "error", message: vm.errorMessage(e) });
        }
      } finally {
        vm.loading = false;
      }
    },
    openProducts(row) {
      const products = (row && row.ROW_RAW && row.ROW_RAW.products) ? row.ROW_RAW.products : [];
      this.selectedProducts = products;
      this.selectedRowKey = row && row.key ? row.key : null;
      this.dialogProducts = true;
    },
    tableRowClassName: function (row, rowIndex) {
      if (row.status === "Erro") {
        return "warning-row";
      } else if (row.status === "Sucesso") {
        return "success-row";
      }
      return "";
    },
    dc(record) {
      const vm = this;
      vm.current = record;
      vm.$refs.dc.open(record.prepost.dc);
    },
    saveDc(list) {
      const vm = this;
      vm.tableData[vm.current.index].dc = list;
    },
    back() {
      const vm = this;
      vm.$emit("back");
    },
    prepost() {
      const vm = this;
      vm.loading = true;
      PrepostService.xml(vm.customer, vm.xml)
        .then((res) => {
          var has = false;
          for (const row of res) {
            if (row.status === "error") has = true;
            console.log("vm.xml.tag", vm.xml.tag);
            const record = vm.xml.tag.find((x) => x.tag === row.tag);
            if (record) {
              record.status = row.status === "error" ? "Erro" : "Sucesso";
              record.result = row.message;
            }
          }
          console.log(res);
          if (has) {
            return this.$message({
              type: "warning",
              message: "Alguns objetos não foram importados, verifique os erros na tabela acima",
            });
          }
          return this.$message({
            type: "success",
            message: "Importação realizada com sucesso!",
          });
        })
        .catch((err) => {
          console.log("err", err);
          return this.$message({
            type: "error",
            message: err,
          });
          //          vm.xml.tag[index].result = err
        })
        .finally(() => (vm.loading = false));
    },
    create() {
      const vm = this;
      const success = vm.tableData.filter((x) => x.status === "Sucesso");
      if (success && success.length === 0) {
        return this.$message({
          type: "error",
          message: "Nenhuma linha da planilha foi validada com sucesso, sem pre-postagens para criação!",
        });
      }
      const errors = vm.tableData.filter((x) => x.status === "Erro");
      if (errors && errors.length > 0) {
        this.$confirm(
          `Existem linhas ainda com erros, para essas linhas não serão criadas as pre-postagens, deseja continuar?`,
          i18n.tc("aviso"),
          {
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            type: i18n.tc("aviso"),
            center: true,
          }
        ).then(() => {
          vm.$emit("create", success);
          vm.$emit("next");
        });
      } else {
        vm.$emit("create", success);
        vm.$emit("next");
      }
    },
    correct(record) {
      const vm = this;
      const fields = Object.keys(record.data);
      vm.data = [];
      for (let i = 0; i < fields.length; i++) {
        vm.data.push({
          index: i,
          column: `Coluna ${vm.generate(i).toUpperCase()}`,
          value: record.data[fields[i]],
          field: fields[i],
        });
      }
      vm.current = record;
      vm.dialog = true;
    },
    save() {
      const vm = this;
      let newData = {};
      vm.loading = true;
      for (const record of vm.data) {
        newData[record.field] = record.value;
      }
      vm.tableData[vm.current.index].data = newData;
      vm.setPrepostData(newData, vm.current.index);
      vm.dialog = false;
    },
    generate(a) {
      var b = [a],
        sp,
        out,
        i,
        div;
      sp = 0;
      while (sp < b.length) {
        if (b[sp] > 25) {
          div = Math.floor(b[sp] / 26);
          b[sp + 1] = div - 1;
          b[sp] %= 26;
        }
        sp += 1;
      }

      out = "";
      for (i = 0; i < b.length; i += 1) {
        out = String.fromCharCode("a".charCodeAt(0) + b[i]) + out;
      }

      return out;
    },
    async setPrepostData(data, index) {
      const vm = this;
      let prepostData = {
        prepost: {
          cardpost: "",
          customer: "",
          primary: "",
          service: "",
          value: 0,
          sender: {},
          delivery: {},
          contact: {},
          object: {},
          complement: {},
          dc: [],
        },
      };

      let customer = vm.customer;
      try {
        if (data.FILIAL) {
          try {
            const response = await CustomerService.branchName(vm.customer, data.FILIAL);
            customer = response.id;
          } catch (e) {
            prepostData.error = `CAMPO "FILIAL" ERRO: ${e}`;
          }
        }
        if (data.CARTAO) {
          try {
            const response = await CustomerService.customerCardpost(customer, data.CARTAO);
            prepostData.prepost.cardpost = response.code;
          } catch (e) {
            prepostData.error = `CAMPO "CARTAO" ERRO: ${e}`;
          }
        } else {
          try {
            const response = await CustomerService.cardpost(customer);
            prepostData.prepost.cardpost = response.code;
          } catch (e) {
            prepostData.error = `CAMPO "CARTAO" ERRO: ${e}`;
          }
        }

        if (data.CEP_REM && data.CEP_REM.length < 8) {
          data.CEP_REM = data.CEP_REM.padStart(8, "0");
        }

        if (data.CEP_REM) {
          try {
            const response = await PostOfficeService.zipcode(data.CEP_REM);
            prepostData.prepost.sender = {
              cep: response.cep,
              contact: data.NOME_REM ? data.NOME_REM : "",
              address: data.ENDERECO_REM ? data.ENDERECO_REM : response.end,
              neighborhood: data.BAIRRO_REM ? data.BAIRRO_REM : response.bairro,
              city: data.CIDADE_REM ? data.CIDADE_REM : response.cidade,
              state: data.UF_REM ? data.UF_REM : response.uf,
              number: data.NUMERO_REM ? data.NUMERO_REM : "",
              extent: data.COMPLEMENTO_REM ? data.COMPLEMENTO_REM : "",
            };
          } catch (e) {
            prepostData.error = `CAMPO "CEP_REM" ERRO: ${e}`;
          }
        } else {
          try {
            const response = await CustomerService.get(customer);
            prepostData.prepost.sender = {
              cep: response.zipcode.zipcode,
              contact: data.NOME_REM ? data.NOME_REM : response.name,
              address: data.ENDERECO_REM ? data.ENDERECO_REM : response.zipcode.address,
              neighborhood: data.BAIRRO_REM ? data.BAIRRO_REM : response.zipcode.neighborhood,
              city: data.CIDADE_REM ? data.CIDADE_REM : response.zipcode.city,
              state: data.UF_REM ? data.UF_REM : response.zipcode.state,
              number: data.NUMERO_REM ? data.NUMERO_REM : response.number,
              extent: data.COMPLEMENTO_REM ? data.COMPLEMENTO_REM : response.extent,
            };
          } catch (e) {
            prepostData.error = `CAMPO "CEP_REM" ERRO: ${e}`;
          }
        }

        if (data.CEP && data.CEP.length < 8) {
          data.CEP = data.CEP.padStart(8, "0");
        }
        prepostData.prepost.primary = data.ETIQUETA_PRIMARIA || "";
        prepostData.prepost.delivery = {
          delivery: null,
          branch: null,
          department: data.DEPARTAMENTO ? data.DEPARTAMENTO : "",
          cep: data.CEP,
          contact: "",
          address: data.ENDERECO ? data.ENDERECO : "",
          neighborhood: data.BAIRRO ? data.BAIRRO : "",
          city: data.CIDADE ? data.CIDADE : "",
          state: data.UF ? data.UF : "",
          number: data.NUMERO ? data.NUMERO : "",
          extent: data.COMPLEMENTO ? data.COMPLEMENTO : "",
          name: data.DESTINATARIO ? data.DESTINATARIO : "",
        };
        try {
          const response = await PostOfficeService.zipcode(data.CEP, "delivery");
          if (response) {
            prepostData.prepost.delivery.address = data.ENDERECO ? data.ENDERECO : response.end;
            prepostData.prepost.delivery.neighborhood = data.BAIRRO ? data.BAIRRO : response.bairro;
            prepostData.prepost.delivery.city = data.CIDADE ? data.CIDADE : response.cidade;
            prepostData.prepost.delivery.state = data.UF ? data.UF : response.uf;
          }
        } catch (e) {
          prepostData.error = `CAMPO "CEP" ERRO: ${e}`;
        }
        // CRIAÇÃO DA PRÉ-POSTAGEM
        prepostData.prepost.contact = {
          save: "",
          invoice: data.NOTA ? data.NOTA : "",
          request: data.PEDIDO ? data.PEDIDO : "",
          care: data.AC ? data.AC : "",
          mail: data.EMAIL_DESTINO ? data.EMAIL_DESTINO : "",
          phone: data.TELEFONE_DESTINO ? data.TELEFONE_DESTINO : "",
          federalid: data.CPF_CNPJ ? data.CPF_CNPJ : "",
          observation: data.OBSERVACAO ? data.OBSERVACAO : "",
          whatsapp:
            data.WHATSAPP &&
            (data.WHATSAPP.toUpperCase() == "S" || data.WHATSAPP.toUpperCase() == "SIM" || data.WHATSAPP == "1")
              ? true
              : false,
        };

        prepostData.prepost.object = {
          package: data.EMBALAGEM ? data.EMBALAGEM : "",
          mdp: "",
          quantity: 1,
          ar:
            data.AR && (data.AR.toUpperCase() == "S" || data.AR.toUpperCase() == "SIM" || data.AR == "1")
              ? true
              : false,
          ownhand:
            data.MP && (data.MP.toUpperCase() == "S" || data.MP.toUpperCase() == "SIM" || data.MP == "1")
              ? true
              : false,
          ap:
            data.AP && (data.AP.toUpperCase() == "S" || data.AP.toUpperCase() == "SIM" || data.AP == "1")
              ? true
              : false,
          reg: data.REGISTRADO ? data.REGISTRADO : "",
          urg: data.URGENTE ? data.URGENTE : "",
          weight: data.PESO,
          type: data.TIPO ? data.TIPO : "",
          object: data.OBJETO ? data.OBJETO : "",
        };

        const isentoDce = data.ISENTO_DCE ? String(data.ISENTO_DCE).toUpperCase() : "";
        const dceExempt = isentoDce == "S" || isentoDce == "SIM" || isentoDce == "1";

        prepostData.prepost.complement = {
          type: data.TIPO ? data.TIPO : "001",
          width: data.LARGURA ? +data.LARGURA : 0,
          height: data.ALTURA ? +data.ALTURA : 0,
          length: data.COMPRIMENTO ? +data.COMPRIMENTO : 0,
          value: data.VALOR_DECLARADO ? data.VALOR_DECLARADO : 0,
          typeContent: data.CHAVE_NFE ? '1' : dceExempt ? '5' : data.DCE_EMITE === 'SIM' ? '3' : '4',
          nfeKey: data.CHAVE_NFE || "",
          nfeValue: String(data.VALOR_NFE || ""),
          nfeNumber: Number(data.NUMERO_NFE || ""),
          nfeSerie: Number(data.SERIE_NFE || ""),
        };

        try {
          const response = await UploadService.getServiceData(data.SERVICO);
          prepostData.prepost.service = response.code;
        } catch (e) {
          prepostData.error = `CAMPO "SERVICO" ERRO: Serviço não localizado. LINHA ${index + 1}`;
        }

        if (data.DCE_PRODUTO) {
          const productList = data.DCE_PRODUTO ? data.DCE_PRODUTO.split("#") : [];
          const quantityList = data.DCE_QTD ? data.DCE_QTD.split("#") : [];
          const valueList = data.DCE_VALOR ? data.DCE_VALOR.split("#") : [];
          if (productList.length !== quantityList.length || productList.length !== valueList.length) {
            prepostData.error = `CAMPO "DC PRODUTO" NÃO COMPATIVEL COM OS CAMPOS "DC QTD" E "DC VALOR", VERIFIQUE SE O SEPARADOR # DOS CAMPOS`;
          } else {
            for (let i = 0; i < productList.length; i++) {
              const quantity = quantityList[i].replace(",", ".");
              const value = valueList[i].replace(",", ".");
              prepostData.prepost.dc.push({
                content: productList[i],
                quantity: isNaN(+quantity) ? 1 : +quantity,
                value: isNaN(+value) ? 1 : +value,
              });
            }
          }
        }
      } catch (e) {
        console.log(e);
        prepostData.error = `ERRO: ${e}`;
      }
      prepostData.prepost.customer = customer;

      try {
        const validateResponse = await PrepostService.validate(prepostData.prepost);
        prepostData.prepost.value = validateResponse;
      } catch (e) {
        prepostData.error = `ERRO: ${vm.errorMessage(e)}`;
      }
      Promise.all([prepostData])
        .then((res) => {
          const response = res[0];
          vm.tableData[index].prepost = response.prepost;
          vm.tableData[index].status = response.error ? "Erro" : "Sucesso";
          vm.tableData[index].result = response.error ? response.error : "";
        })
        .catch((err) => {
          vm.tableData[index].status = "Erro";
          vm.tableData[index].result = err;
        })
        .finally(() => (vm.loading = false));
    },
  },
};
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.w-50 {
  width: 50%;
}

h4 {
  margin-bottom: 5px;
  color: #444;
}
.p-4 {
  padding: 16px;
}
.bg-gray-50 {
  background-color: #fafafa;
}
.rounded-md {
  border-radius: 6px;
}

.expand .el-table__expand-icon:hover {
  color: red !important;
}

.el-table__body-wrapper {
  overflow-x: auto !important;
}

.el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
}

.validate-title {
  margin: 15px 0 10px;
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  text-transform: uppercase;
}

.validate-title .el-tag {
  margin-left: 8px;
  text-transform: none;
}

.validate-footer {
  margin-top: 20px;
  text-align: right;
}

.validate-cotar-wrap {
  display: inline-block;
  margin-left: 10px;
}
</style>

<!-- Regras que precisam alcançar elementos internos do Element (fora do scoped) -->
<style>
.input-error .el-input__inner {
  border-color: #f56c6c !important;
}

.status-tag {
  white-space: normal;
  height: auto;
  line-height: 1.4;
  padding-top: 4px;
  padding-bottom: 4px;
}

.status-errors {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.status-error-link {
  cursor: pointer;
  margin: 2px 0;
  display: flex;
  align-items: center;
}

.status-error-link .el-icon-arrow-right {
  margin-left: auto;
  padding-left: 8px;
}

.status-error-text:hover {
  text-decoration: underline;
}
</style>